export const UI_STORE = 'uiStore';
export const OBCINE_STORE = 'obcineStore';
export const ERRORS_STORE = 'errors';
export const PHYSICAL_OBJECT_STORE = 'poStore';
export const RESULTS_TAB = 'resultsTab';

// Inputs, buttons, and headers already have default roles, so no need to assign explicit roles.
// Non-interactive elements requiring keyboard access are labeled as "textbox" to ensure screen readers do not misinterpret them as "clickable."
export const ACCESSIBILITY_ROLE = 'textbox';
//TabIndexes will be set to majority of elements on the page to allow easy access and web flow with the use of the keyboard.
//We want to prevent the use of higher tab indexes than 0 to maintain a natural DOM order on the page. This ensures scalability and keeps the page accessible when new elements are added.
export const TAB_IDX_DEFAULT = 0;

function getRevPath(date) {
  return date ? '?date=' + encodeURIComponent(date) : '';
}

export const SearchType = {
  PARCEL: {
    id: 'parcela',
    label: 'Parcela',
    query: 'parcela',
  },
  BUILDINGPART: {
    id: 'delStavbe',
    label: 'Del stavbe',
    query: 'delStavbe',
  },
  BUILDING: {
    id: 'stavba',
    label: 'Stavba',
    query: 'stavba',
  },
  OBCINA: {
    id: 'obcina',
    label: 'Občina',
    query: 'obcina',
  },
  SPECIAL_UNIT: {
    id: 'posebna',
    label: 'Posebna enota',
    userOnly: true,
    hidden: true,
    query: 'posebna',
  },
  OWNER: {
    id: 'oseba',
    label: 'Lastnik',
    iconName: 'user',
    hidden: true,
    userOnly: true,
    query: 'oseba',
  },
};

export const QUERY_URLS = {
  PARCEL: {
    base: function (id, rev) {
      return `/podatki/${SearchType.PARCEL.query}/${id}${getRevPath(rev)}`;
    },
    buildings: function (id, rev) {
      return `${this.base(id)}/staPar${getRevPath(rev)}`;
    },
    owners: function (id, rev) {
      return `${this.base(id)}/${SearchType.OWNER.query}${getRevPath(rev)}`;
    },
    buildingPart: function (id, rev) {
      return `${this.base(id)}/${SearchType.BUILDINGPART.query}${getRevPath(rev)}`;
    },
    actualUse: function (id, rev) {
      return `${this.base(id)}/dejanskaRabaParcele${getRevPath(rev)}`;
    },
    purposeUse: function (id, rev) {
      return `${this.base(id)}/namenskaRabaParcele${getRevPath(rev)}`;
    },
    parcDeli: function (id, rev) {
      return `${this.base(id)}/parcDel${getRevPath(rev)}?expandEnota=true`;
    },
    vplivi: function (id, rev) {
      return `${this.base(id)}/vpliv${getRevPath(rev)}`;
    },
    posebne: function (id, rev) {
      return `${this.base(id)}/posebna${getRevPath(rev)}`;
    },
    values: function (id, rev) {
      return `${this.base(id)}/vrednost${getRevPath(rev)}?expandOkoliscine=true`;
    },
    valuesJn: function (id, rev) {
      return `${this.base(id)}/vrednost/revisions${getRevPath(rev)}`;
    },
  },
  OWNER: {
    base: function (id, rev) {
      return `/podatki/${SearchType.OWNER.query}/${id}${getRevPath(rev)}`;
    },
    parcels: function (id, rev) {
      return `${this.base(id)}/${SearchType.PARCEL.query}${getRevPath(rev)}`;
    },
    buildingPart: function (id, rev) {
      return `${this.base(id)}/${SearchType.BUILDINGPART.query}${getRevPath(rev)}`;
    },
  },
  BUILDING: {
    base: function (id, rev) {
      return `/podatki/${SearchType.BUILDING.query}/${id}${getRevPath(rev)}`;
    },
    staPars: function (id, rev) {
      return `${this.base(id)}/staPar${getRevPath(rev)}`;
    },
    buildingPart: function (id, rev) {
      return `${this.base(id)}/${SearchType.BUILDINGPART.query}${getRevPath(rev)}`;
    },
  },
  BUILDINGPART: {
    base: function (id, rev) {
      return `/podatki/${SearchType.BUILDINGPART.query}/${id}${getRevPath(rev)}`;
    },
    owners: function (id, rev) {
      return `${this.base(id)}/${SearchType.OWNER.query}${getRevPath(rev)}`;
    },
    vplivi: function (id, rev) {
      return `${this.base(id)}/vpliv${getRevPath(rev)}`;
    },
    posebne: function (id, rev) {
      return `${this.base(id)}/posebna${getRevPath(rev)}`;
    },
    buildingPart: function (id, rev) {
      return `${this.base(id)}/${SearchType.BUILDINGPART.query}${getRevPath(rev)}`;
    },
    valuesJn: function (id, rev) {
      return `${this.base(id)}/vrednost/revisions${getRevPath(rev)}`;
    },
  },
  SPECIAL_UNIT: {
    base: function (id, rev) {
      return `/podatki/${SearchType.SPECIAL_UNIT.query}/${id}${getRevPath(rev)}`;
    },
    podatek: function (id, rev) {
      return `${this.base(id)}/podatek${getRevPath(rev)}`;
    },
    parcel: function (id, rev) {
      return `${this.base(id)}/${SearchType.PARCEL.query}${getRevPath(rev)}`;
    },
    buildingPart: function (id, rev) {
      return `${this.base(id)}/${SearchType.BUILDINGPART.query}${getRevPath(rev)}`;
    },
  },
};
